"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var core_1 = require("@angular/core");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
require("rxjs/add/operator/switchMap");
var MultilingualPipe = /** @class */ (function () {
    function MultilingualPipe(currentLanguageProvider) {
        this.currentLanguageProvider = currentLanguageProvider;
    }
    MultilingualPipe.prototype.transform = function (value) {
        var observable = this.currentLanguageProvider.getCurrentLanguage();
        return observable.switchMap(function (language) {
            var result = '';
            if (value instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
                result = value.getValue(language.getId());
            }
            else if (value instanceof Map) {
                result = value.get(language.getId());
            }
            return Observable_1.Observable.of(result);
        });
    };
    MultilingualPipe.decorators = [
        { type: core_1.Pipe, args: [{
                    name: 'multilingual',
                    pure: true,
                },] },
    ];
    /** @nocollapse */
    MultilingualPipe.ctorParameters = function () { return [
        { type: idm_session_data_provider_api_js_1.CurrentLanguageProvider, },
    ]; };
    return MultilingualPipe;
}());
exports.MultilingualPipe = MultilingualPipe;
//# sourceMappingURL=multilingual.pipe.js.map